module.exports = __webpack_public_path__ + "img/ajax.781098c0.png";